import React, { useContext, useEffect } from 'react';

import { PagesContext } from '../store/PagesContext';

import bee from '../assets/images/bee.png';

import purplePolygon from '../assets/images/svg/purple-polygon.svg';
import star from '../assets/images/star-purple.png';

import Intro from 'routes/decision-trees/components/Intro';
import Description from 'routes/decision-trees/components/Description';
import Hint from 'routes/decision-trees/components/Hint';

const Nso = () => {
  const [, setLastPage] = useContext(PagesContext);

  useEffect(() => setLastPage('isoD'), []);

  return (
    <>
      <div className='mw-700 m-auto py-sm-5'>
        <Intro background={purplePolygon} withCongrats={star} withBee={bee}>
          <h2 className='my-5'>
            Congrats,
            <br />
            you exercised
            <br />
            your NSOs!
          </h2>
        </Intro>

        <Description>
          Before you can turn your shares into gains, you need to be made aware of the coming tax liabilities that will impact your
          financial future. This tree can help you discover those liabilities!
        </Description>

        <Hint>Click anywhere on the screen to get started.</Hint>
      </div>
    </>
  );
};

export default Nso;
